import React from 'react';
import { MainSearch } from 'us.common/components';

const Cnt_MainSearch: React.FC<any> = (props) => {
	return <MainSearch {...props} />;
};

export default Cnt_MainSearch;
